import { CartProductDto } from '../../dto/cartProduct.dto';

export interface PosCartProductMultipleQuantitiesDialogResult {
  selectedCartProduct?: CartProductDto;
  isCartProductMultipleQuantitiesSelection?: boolean;
  selectedSaleUnitCartId?: number;
  selectedSaleUnitCartSplitId?: number;
  splitProductQuantity?: number;
}
